const AUTH_RESPONSE_TYPE = 'code';
const AUTH_RESPONSE_MODE = 'query';
const AUTH_CHALLENGE_METHOD = 'S256';

const AUTH_URL = process.env.NEXT_PUBLIC_AUTH_URL as string;
const AUTH_TENANT = process.env.NEXT_PUBLIC_AUTH_TENANT as string;
const AUTH_POLICY = process.env.NEXT_PUBLIC_AUTH_POLICY as string;

export const OAUTH_BASE_PATH = `${AUTH_URL}/${AUTH_TENANT}.onmicrosoft.com/${AUTH_POLICY}`;
export const AUTH_CLIENT_ID = process.env.NEXT_PUBLIC_AUTH_CLIENT_ID as string;
export const AUTH_REDIRECT_URI = process.env.NEXT_PUBLIC_REDIRECT_URI as string;
export const AUTH_LOGOUT_REDIRECT_URI = process.env.NEXT_PUBLIC_LOGOUT_REDIRECT_URI as string;
export const AUTH_SCOPE = process.env.NEXT_PUBLIC_AUTH_SCOPE as string;
export const AUTH_REFRESH_TOKEN_URL = `${OAUTH_BASE_PATH}/oauth2/v2.0/accessToken`;
export const AUTH_AUTHORIZE_URL =
  process.env.NEXT_PUBLIC_AUTHORIZE_URL ||
  `${OAUTH_BASE_PATH}/oauth2/v2.0/authorize?client_id=${AUTH_CLIENT_ID}&response_type=${AUTH_RESPONSE_TYPE}&redirect_uri=${AUTH_REDIRECT_URI}&response_mode=${AUTH_RESPONSE_MODE}&code_challenge_method=${AUTH_CHALLENGE_METHOD}&scope=${AUTH_SCOPE} offline_access`;
export const AUTH_TOKEN_URL = process.env.NEXT_PUBLIC_TOKEN_URL || `${OAUTH_BASE_PATH}/oauth2/v2.0/token`;
export const AUTH_TOKEN_WARP_URL = `${process.env.NEXT_PUBLIC_WARP_BASE_URL}/login`;
export const AUTH_LOGOUT_URL = `${OAUTH_BASE_PATH}/oauth2/v2.0/logout?post_logout_redirect_uri=${AUTH_LOGOUT_REDIRECT_URI}`;
export const OPEN_ID_CONFIG_URL = `${OAUTH_BASE_PATH}/v2.0/.well-known/openid-configuration`;
